import { useContext, createContext } from 'react';

import { useNotificationsHub } from 'src/hooks/use-notifications-hub';

// Context oluştur
const NotificationHubContext = createContext(null);

// Provider bileşeni
export function NotificationHubProvider({ children }) {
  const hub = useNotificationsHub();

  return <NotificationHubContext.Provider value={hub}>{children}</NotificationHubContext.Provider>;
}

// Custom hook (kullanımı kolaylaştırır)
export function useNotificationHubContext() {
  const context = useContext(NotificationHubContext);
  if (!context) {
    throw new Error('useNotificationHubContext must be used within a NotificationHubProvider');
  }
  return context;
}
